import Vue from 'vue'
import VueRouter from 'vue-router'
import VueHead from 'vue-head'
import routeImporter from './routeImporter'

window.pathApp = process.env.PATH

Vue.use(VueHead, {
    separator: ' - '
})
Vue.use(VueRouter)

const routes = routeImporter(require.context('./routes', false, /.*\.js$/))

const router = new VueRouter({
    mode: 'history',
    routes: routes,
    scrollBehavior (to, from, savedPosition) {
        var coordenates = $('body').offset()
        var body = $("html, body")
        body.stop().animate({scrollTop:coordenates.top}, '500', 'swing')
        return false
    }
})

export default router;


// WEBPACK FOOTER //
// ./src/router/router.js